<template>
  <button
    :id="idPopover"
    class="default-button button-filter filter tw-px-4 tw-py-4 tw-flex tw-items-center tw-bg-[white]"
    :class="{
      'disable-button': !active,
      'border-button': hasBorder,
      'margin-mobile': hasBorder,
      '!tw-bg-[#211F58]': onHoverStatus,
    }"
    @mouseover="openModal(true)"
  >
    <sortIcon :color="`${onHoverStatus ? 'white' : '#211F58'}`" />

    <span
      :class="`tw-pl-2 ${
        onHoverStatus ? 'tw-text-[#FFF]' : 'tw-text-[#211F58] '
      } tw-text-[10px] text-sort`"
      >{{ getUiText("app-notification-sort-1") }}</span
    >
  </button>
  <CustomDropDown
    :id-popover="idPopover"
    :class="!showMoreActions ? 'tw-invisible' : ''"
    class="notification-sort"
    @click="openModal(false)"
    @on-hover="onHover"
  >
    <template v-if="showMoreActions" #default>
      <slot />
    </template>
  </CustomDropDown>
</template>

<script lang="ts">
import store from "@/store";
import utilities from "@/utils/utilities";
import { Component, Prop, Vue } from "vue-facing-decorator";
import { Ref, ref } from "vue";
import CustomDropDown from "../customDropDown.vue";
import sortIcon from "@/components/svgs/sortIcon.vue";
@Component({
  components: { CustomDropDown, sortIcon },
})
export default class ButtonSort extends Vue {
  @Prop({ required: true }) readonly active: boolean = false;
  @Prop({ required: false }) readonly hasBorder: boolean = false;
  @Prop({ required: true }) idPopover = "";
  public showMoreActions: Ref = ref(false);
  public onHoverStatus: Ref = ref(false);

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  getUiText(id: string, isArray = false) {
    return utilities.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  public openModal = (value) => {
    this.showMoreActions.value = value;
  };
  onHover = (value) => {
    this.onHoverStatus.value = value;
  };
}
</script>

<style scoped lang="scss">
.default-button {
  border: none;
  height: 44px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.border-button {
  border-radius: 6px;
  border: 1px solid var(--ui-rule, #eff0f1);
  padding: 14px 16px !important;
}

.text-sort {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.action-button {
  display: flex;
  justify-content: center;
  padding: 0 20px 0 19px;
}

.custom-actions-popover .popover-arrow {
  width: 14px;
  height: 14px;
}

.custom-actions-popover.bs-popover-bottom {
  margin-top: unset;
  .popover-arrow {
    top: -8px;
  }
}

.custom-actions-popover.bs-popover-top {
  .popover-arrow {
    bottom: -8px;
  }
}

.popover {
  border: none;
  box-shadow: 0px 0px 25px 0px rgba(177, 176, 176, 0.35);
  border-radius: 6px;
}

.popover-body {
  padding: 0;
  min-width: 160px;
}

.decorator-modal-more {
  transform: rotate(45deg);
  width: 20px;
  height: 20px;
  background: white;
  position: absolute;
  top: -8px;
  left: 20px;
}
@media (max-width: 479px) {
  .margin-mobile {
    margin-top: 10px;
  }
}
</style>
